import React from "react";
import styled from "styled-components";
import {PurpleReverseButton} from "./ButtonStyles";

const ContinueButton = ({ toggleHandler, canProcess }) => {
    return(
        <Button
            className={"next-btn"}
            onClick={() => canProcess !== false ? toggleHandler('next'): null}>
            <p> Suivant </p>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" transform="rotate(90 12 12)" fill="#4909AA"/>
                <path
                    d="M14.6891 16.1611L10.5645 11.9946L14.6891 7.82819C15.1036 7.4094 15.1036 6.73289 14.6891 6.31409C14.2745 5.8953 13.6048 5.8953 13.1902 6.31409L8.31093 11.243C7.89636 11.6617 7.89636 12.3383 8.31093 12.757L13.1902 17.6859C13.6048 18.1047 14.2745 18.1047 14.6891 17.6859C15.093 17.2671 15.1036 16.5799 14.6891 16.1611Z"
                    fill="white"/>
            </svg>
        </Button>
    )
}

const Button = styled(PurpleReverseButton)`
  width: 3rem;
  p{
    display: none;
    font-weight: 500;
  }
  svg{
    transform: rotate(180deg);
  }
  @media (min-width: 1200px) {
    width: 12rem;
    p{
      display: initial;
    }
  }
`

export default ContinueButton;